import { render, staticRenderFns } from "./Pets.vue?vue&type=template&id=39d026c4&"
import script from "./Pets.vue?vue&type=script&lang=ts&"
export * from "./Pets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports